module.exports = __webpack_public_path__ + "cd42646b76f9b466b0fa466f553bc0c0.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/url-loader??ref--8-1!./node_modules/image-webpack-loader??ref--8-2!./node_modules/srcset-loader/lib/resize-loader.js?size=600!./src/components/cover/teaser-dark.png?size=600w
// module id = 38
// module chunks = 1